import styled, { css } from 'styled-components';
export const OptionWrapper = styled.div`
  background: transparent;
  ${props => props.hover && css`
      background: rgba(53, 59, 96, 0.05);
    `}
  ${props => props.active && css`
      background: rgba(92, 130, 229, 0.15);
    `}
  ${props => props.active && props.hover && css`
      background: linear-gradient(
          rgba(53, 59, 96, 0.05),
          rgba(53, 59, 96, 0.05)
        ),
        linear-gradient(rgba(92, 130, 229, 0.15), rgba(92, 130, 229, 0.15));
    `}
  padding: 9.5px 12px;
  color: #353b60;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  user-select: none;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 14px;
  word-break: break-all;

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;